module.exports = __webpack_public_path__ + "static/media/summaryBorder.7b2aa01d.svg";